import styled from 'styled-components';
import { unitizedPx } from '@badi/badi-components';

export const Root = styled.div`
  margin-top: ${unitizedPx(-18)};
`;
